import axios from 'axios';

import { extractData } from '@/api/ApiHelpers';

import type { PaasStddevResponse } from '@/api/ApiTypes';


const paasStddevGet = (
	handler: (responseData: PaasStddevResponse) => void,
	errorHandler: (error: unknown) => void,
): void => {
	axios.get('/rinex/get_paas_stddev/').then(extractData(handler)).catch(errorHandler);
};


export default {
	paasStddevGet,
};
